﻿import { token } from "../../token";
import { v1_3_request_booking_search_criteria} from "./v1_3_request_booking_search_criteria";

export class booking_search_request {
    public token: token = new token();
    public criteria: v1_3_request_booking_search_criteria = new v1_3_request_booking_search_criteria();
}